import { Row, Col } from 'react-bootstrap';
import PercentageField from '../fields/PercentageField';
import CurrencyField from '../fields/CurrencyField';

const CalculatedBenefitResults = ({
  energyDiscount,
  pledgeAmount,
  isSubmitting,
}) => {

  return (
    <Row>
      <h4>Benefit Amount{pledgeAmount !== null? 's': ''}</h4>
      <Col md={6}>
        <PercentageField
          value={energyDiscount}
          fieldName="Energy Discount"
          readonly
          disabled
          isSubmitting={isSubmitting}
          />
      </Col>
      {pledgeAmount && (
      <Col md={6}>
        <CurrencyField
          value={pledgeAmount}
          fieldName="Total AMP Instant Grant Relief Amount"
          readonly
          disabled
          isSubmitting={isSubmitting}
        />
      </Col>
      )}
    </Row>
  );
};

export default CalculatedBenefitResults;